<template>
  <FinancialsOverviewCard title="Remaining Debt Balance" expandable>
    <template #default>
      <div class="d-flex align-center">
        <h4 class="text-h4 text-danger">
          {{ remainingDebtBalance }}
        </h4>
      </div>
    </template>
    <template #details>
      <dl class="dl-vertical">
        <dt>Total debt amount:</dt>
        <dd>{{ totalDebt }}</dd>
      </dl>
    </template>
  </FinancialsOverviewCard>
</template>

<script lang="ts">
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { defineComponent } from "vue"
  import FinancialsOverviewCard from "../../components/FinancialsOverviewCard.vue"

  export default defineComponent({
    components: {
      FinancialsOverviewCard,
    },
    data() {
      return {
        debtPaymentPlan: useCurrentAccountStore().activeDebtPaymentPlan,
      }
    },
    computed: {
      remainingDebtBalance() {
        const amount = this.debtPaymentPlan?.data?.remainingBalance
        if (!amount && amount !== 0) return
        return formatMoney({ amount, showNegativeSign: false })
      },
      totalDebt() {
        const amount = this.debtPaymentPlan?.data?.totalDebt
        if (!amount && amount !== 0) return
        return formatMoney({ amount, showNegativeSign: false })
      },
    },
  })
</script>
